import { render, staticRenderFns } from "./CatalogHeadOuter.vue?vue&type=template&id=e4bee412&scoped=true"
import script from "./CatalogHeadOuter.vue?vue&type=script&lang=js"
export * from "./CatalogHeadOuter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bee412",
  null
  
)

export default component.exports